<div class="attribute-panel">
  <div class="hierarchy-section">
    <h4>階層1</h4>
    <div class="attribute-item" *ngFor="let attr of hierarchyOneAttributes">
      <span class="label">{{attr.label}}：</span>
      <span class="value">{{attr.value || (attr.key && model.others[attr.key])}}</span>
    </div>
  </div>
  <div class="hierarchy-section">
    <h4>階層2</h4>
    <div class="attribute-item" *ngFor="let attr of hierarchyTwoAttributes">
      <span class="label">{{attr.label}}：</span>
      <span class="value">{{attr.value}}</span>
    </div>
  </div>
</div>
